<template>
    <div class="z-site-selector">
        <template v-for="item in list">
            <a
                v-if="!item.active"
                :key="item.lid"
                :href="item['path-changed']"
                class="z-site-selector__site"
                :class="{ 'z-site-selector__site--invert' : invertColor }"
            >
                <span v-html="item.lang"></span>
            </a>
        </template>
    </div>
</template>

<script>
export default {
    name: 'z-site-selector',
    data: function () {
        return {
            list: this.$root.app.components['site-selector']
        }
    },
    computed: {
        invertColor () {
            return this.$store.getters.menuInvert && !this.$store.getters.menuOpen
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
